module.exports = __webpack_public_path__ + "static/logo-01-4b51e63e85ebbd56be74f8f6aa0fda71.png";